import { render, staticRenderFns } from "./Exit_button.vue?vue&type=template&id=60c49ddf"
import script from "./Exit_button.vue?vue&type=script&lang=js"
export * from "./Exit_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports